import React, { useEffect } from "react";

function useWindowReSize() {
  const [size, setSize] = React.useState<any>({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const onResize = () => {
    setSize({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  };

  useEffect(() => {
    window.addEventListener("resize", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return [size.width, size.height];
}

export default useWindowReSize;
